import Parse from 'parse'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City');

class Category extends Parse.Object {
  constructor() {
    super('Category');
  }

  get name (){
    return this.get('name')
  }

  get note (){
    return this.get('note')
  }

  static load(){
    return new Parse.Query(this)
      .descending('createdAt')
      .find()
  }

  dump () {
    console.log(this)
  }
}

export default Category
